import { reactive, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { isMobile } from '@/utils'
import { toastService } from '@/utils/toastService'
import { useI18n } from 'vue-i18n'
import Api from '@/config/api'
import CnyActApi from '@/config/cnyActApi'
import MwrActApi from '@/config/mwrActApi'
import SfActApi from '@/config/sfActApi'
import PoolPartyActApi from '@/config/poolPartyActApi'
import vnUserGuideImg from '@/assets/imgs/userGuide2/vi.jpg'
import hkUserGuideImg from '@/assets/imgs/userGuide2/hk.jpg'
import thUserGuideImg from '@/assets/imgs/userGuide2/th.jpg'
import idUserGuideImg from '@/assets/imgs/userGuide2/id.jpg'
import enUserGeneImg from '@/assets/imgs/userGuide2/en.jpg'
import { showImagePreview } from 'vant'
import { useLog } from '@/composables/useLog'
export default function useValidateUser(emit, type = '') {
  const { t, locale } = useI18n()
  const store = useStore()
  const log = useLog()
  const state = reactive({
    type: isMobile ? 'mobile' : 'pc',
    text: 'text',
    locale: computed(() => store.state.locale),
    userId: '',
    cpUserInfo: computed(() => store.state.cpUserInfo),
    tempCpUserInfo: {},
    queryTimestamps: [], // 添加查询时间戳数组
    dialog: {
      visible: false,
    },
    userGuideImg: computed(() => {
      if (locale.value === 'vi') {
        return vnUserGuideImg
      } else if (locale.value === 'hk' || locale.value === 'tw') {
        return hkUserGuideImg
      } else if (locale.value === 'th') {
        return thUserGuideImg
      } else if (locale.value === 'id') {
        return idUserGuideImg
      } else {
        return enUserGeneImg
      }
    }),
    imageList: computed(() => [state.userGuideImg]),
    showImageViewer: false,
  })

  const checkQueryTime = () => {
    const now = Date.now()
    const oneMinuteAgo = now - 60 * 1000
    
    // 清除一分钟前的记录
    state.queryTimestamps = state.queryTimestamps.filter(timestamp => timestamp > oneMinuteAgo)
    
    // 检查最近1分钟内的查询次数
    if (state.queryTimestamps.length >= 5) {
      // 查询次数超过限制
      if (type === 'mwr') {
        toastService.showSmall(t('payment.validateUser.queryLimitExceeded'))
      } else {
        toastService.show(t('payment.validateUser.queryLimitExceeded'))
      }
      return false
    }
    
    // 记录本次查询时间戳
    state.queryTimestamps.push(now)
    return true
  }

  const handleSubmit = async () => {
    if (!state.userId) {
      if (type === 'mwr') {
        toastService.showSmall(t('payment.validateUser.enterUserId'))
      } else {
        toastService.show(t('payment.validateUser.enterUserId'))
      }
      return
    }
    const isPassed = checkQueryTime()
    if (!isPassed) {
      return
    }
    if (type === 'accum') {
      log.track('act_accum_query', {
        v1: state.userId
      })
    }
    if (type === 'poolParty') {
      log.track('act_pp_query', {
        v1: state.userId
      })
    }
    const params = {
      cpUserId: state.userId,
    }
    try {
      const res = await Api.getCpUserInfo(params)
      console.log('getCpUserInfo res', res)
      if (type === 'mwr') {
        res.mwrToken = res.token
      }
      if (res.cpUserId) {
        state.tempCpUserInfo = res
        state.dialog.visible = true
      }
    } catch(error) {
      console.error('getCpUserInfo error', error)
    }
  }

  const handleActSubmit = async (type) => {
    if (!state.userId) {
      if (type === 'mwr') {
        toastService.showSmall(t('payment.validateUser.enterUserId'))
      } else {
        toastService.show(t('payment.validateUser.enterUserId'))
      }
      return
    }
    const isPassed = checkQueryTime()
    if (!isPassed) {
      return
    }
    const params = {
      cpUserId: state.userId,
    }
    try {
      const apiMap = {
        cny: CnyActApi.login,
        sf: SfActApi.login,
        mwr: MwrActApi.login,
        poolParty: PoolPartyActApi.login
      }
      const api = apiMap[type]
      if (!api) {
        toastService.show('invalid type')
        return
      }
      const res = await api(params)
      console.log('getCpUserInfo res', res)
      if (type === 'mwr') {
        res.mwrToken = res.token
      }
      if (res.cpUserId) {
        state.tempCpUserInfo = res
        state.dialog.visible = true
      }
    } catch(error) {
      console.log('getCpUserInfo error', error)
      if (error.tars_ret === 3001) {
        console.log('error.tars_ret === 3001')
        if (type === 'mwr') {
          toastService.showSmall(t('payment.validateUser.userNotFound'))
        } else {
          toastService.show(t('payment.validateUser.userNotFound'))
        }
      }
    }
  }

  const handleConfirm = () => {
    store.commit('SET_CP_USER_INFO', state.tempCpUserInfo)
    state.tempCpUserInfo = {}
    state.dialog.visible = false
    emit('getUserInfoSuccess')
    if (type === 'cny') {
      try {
        log.track('act_cny_validate_user_confirm', {})
      } catch (error) {
        console.error(error)
      }
    } else if (type === 'sf') {
      try {
        log.track('act_sf_validate_user_confirm', {})
      } catch (error) {
        console.error(error)
      }
    } else if (type === 'poolParty') {
      try {
        log.track('act_pool_party_validate_user_confirm', {})
      } catch (error) {
        console.error(error)
      }
    }
  }

  const handleCancel = () => {
    state.tempCpUserInfo = {}
    state.dialog.visible = false
  }

  const resetUserInfo = () => {
    state.tempCpUserInfo = {}
    store.commit('SET_CP_USER_INFO', {})
    emit('resetUserInfo')
  }

  const openUserGuide = () => {
    if (isMobile) {
      const images = state.imageList
      showImagePreview({
        images,
        closeable: true,
        closeIconPosition: 'top-right',
        showIndex: false,
        closeOnClickOverlay: true
      })
    } else {
      state.showImageViewer = true
      document.body.classList.add('lock-scroll')
    }
  }

  const closeImageViewer = () => {
    state.showImageViewer = false
    document.body.classList.remove('lock-scroll')
  }

  watch(() => state.dialog.visible, (newVal) => {
    if (newVal) {
      emit('dialogOpen', true)
    } else {
      emit('dialogOpen', false)
    }
  })

  const setUserId = (userId) => {
    state.userId = userId
  }

  return {
    state,
    handleSubmit,
    handleActSubmit,
    handleConfirm,
    handleCancel,
    resetUserInfo,
    openUserGuide,
    closeImageViewer,
    setUserId
  }
}


